import { Routes, Route } from "react-router-dom";
import { useSelector } from "react-redux";
// ...existing imports...
import Communicator from "../components/Communicator/Communicator";
import ApplicationTable from "../components/V2/IntakeTraige/ApplicationTable";
import AppChatBot from "../components/AppChatBot.jsx";
import EscalationOverview from "../components/EscalationOverview/EscalationOverview";
import CompanyForm from "../components/Integrations/CompanyForm";
import PdfJsonViewerV2 from "../components/PDFViewer/PDFViewerNew";
import Container from "../components/AppetiteManagement/Container";
import Analytics from "../components/Analytics";
import Operations from "../components/Operations";
import CompanyAnalysisLayout from "../components/CompanyAnalysis/CompanyAnalysisLayout.jsx";
import ApplicationDetailsPage from "../components/V2/ApplicationOverview/ApplicationOverview.jsx";
import { AIGeneratedIndicator } from "../components/ui/ai-generated-indicator";
import QuotePage from "../components/V2/Quote/QuotePage";
import LobDetailsPage from "../components/application/LobDetailsPage";
import { ExtractionViewer } from "../components/PDFViewer/ExtractionViewer";
import { InterpretationGuide } from "../components/InterpretationGuide/InterpretationGuide";

// New wrapper to hold common components
const CommonRouteLayout = ({ children, selectedApplicationId }) => (
  <>
    <Communicator selectedApplicationId={selectedApplicationId} />
    {children}
    <AppChatBot className="fixed top-4 right-4" />
    <AIGeneratedIndicator />
  </>
);

function V2Routes () {
  const selectedApplicationId = useSelector(
    state => state.intakeData.selectedAppId
  );
  return (
    <div className="v2-design">
      <Routes>
        <Route
          path="app/details"
          element={
            <CommonRouteLayout selectedApplicationId={selectedApplicationId}>
              <ApplicationTable />
            </CommonRouteLayout>
          }
        />
        <Route
          path="app/intake/:id"
          element={
            <CommonRouteLayout selectedApplicationId={selectedApplicationId}>
              <ApplicationDetailsPage />
            </CommonRouteLayout>
          }
        />
        <Route
          path="app/escalate"
          element={
            <CommonRouteLayout selectedApplicationId={selectedApplicationId}>
              <EscalationOverview />
            </CommonRouteLayout>
          }
        />
        <Route
          path="app/integrations"
          element={
            <CommonRouteLayout selectedApplicationId={selectedApplicationId}>
              <CompanyForm />
            </CommonRouteLayout>
          }
        />
        <Route
          path="app/locations/:id"
          element={
            <CommonRouteLayout selectedApplicationId={selectedApplicationId}>
              <CompanyAnalysisLayout />
            </CommonRouteLayout>
          }
        />
        <Route
          path="app/analytics"
          element={
            <CommonRouteLayout selectedApplicationId={selectedApplicationId}>
              <Analytics />
            </CommonRouteLayout>
          }
        />
        <Route
          path="app/operations"
          element={
            <CommonRouteLayout selectedApplicationId={selectedApplicationId}>
              <Operations />
            </CommonRouteLayout>
          }
        />
        <Route path="app/pdfviewer" element={<PdfJsonViewerV2 />} />
        <Route path="app/appetite" element={<Container />} />
        <Route
          path="app/quote"
          element={
            <CommonRouteLayout selectedApplicationId={selectedApplicationId}>
              <QuotePage />
            </CommonRouteLayout>
          }
        />
        <Route
          path="app/lob-details/:lobName/:appId"
          element={<LobDetailsPage />}
        />
        <Route path="app/extraction-viewer" element={<ExtractionViewer />} />
        <Route
          path="app/interpretation-guide"
          element={<InterpretationGuide />}
        />
        <Route path="*" element={<div>Page not found</div>} />
      </Routes>
    </div>
  );
}

export default V2Routes;
